// Shared login constants used by the @ow/shared login hooks. Kept here (rather
// than in each app's local constants) so the hooks can live in @ow/shared and be
// consumed identically by the Overwolf app's login + legacy flows.
export const kResendVerificationEndpoint =
  'https://accounts.overwolf.com/auth/action?mode=verifyEmailRequest';

// Login form validators (use-login-validators) — regex + the username-exists
// check endpoint. Shared so both apps validate identically against the same
// rules the shared <LoginSignupForm> reports errors for.
export const kEmailRegex =
  // eslint-disable-next-line max-len
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const kUsernameRegex = /^[a-zA-Z0-9]*$/;
export const kUsernameValidationEndpoint =
  'https://api.overwolf.com/users/CheckUserExist';

// Login form / social config shared by the website and the ow-app in-app login,
// so the two hosts don't drift. The reCAPTCHA v2 site key both hosts pass to the
// shared <LoginSignupForm>:
export const kRecaptchaWidgetId = '6LcBtEUUAAAAANEN8_EB6xA-j4QxQqBg41d2_b5H';
// Subscription-plan + app-icon asset base URLs.
export const kPlanBaseUrl =
  'https://console-api.overwolf.com/v2/subscription-plans/app/';
export const kAppIconBaseUrl =
  'https://storeapi.overwolf.com/asset/logo-image/';
// One-shot session key: "the user already saw the login intro animation".
export const kSawAnimationKey = 'saw-in-app-sub-animation';
